import Routes from '../routes/Routes';

/**
 * URL de création de processus : /process/create/ai ou /process/create/human
 * (IMAGE et HUMAN passent par la page human où l’utilisateur choisit texte/image.)
 */
export function getProcessCreatePath(processType: string | undefined): string {
    const pt = (processType || 'AI').toUpperCase();
    if (pt === 'AI') {
        return `${Routes.PROCESS_CREATE}/ai`;
    }
    return `${Routes.PROCESS_CREATE}/human`;
}
